import React from 'react';
import './App.less';
import RouterComponent from '@/routers';

function App() {
  return <RouterComponent />;
}

export default App;
